/**
 * Centralized query invalidation utilities for level-related queries
 * This ensures consistent invalidation across all level-up triggers
 */

export const invalidateLevelQueries = (queryClient) => {
  if (!queryClient) {
    console.warn("QueryClient not provided to invalidateLevelQueries");
    return;
  }

  // Invalidate all level-related queries
  queryClient.invalidateQueries({ queryKey: ["dashboard", "levelDetails"] });
  queryClient.invalidateQueries({ queryKey: ["dashboard", "weeklyDetails"] });
  queryClient.invalidateQueries({ queryKey: ["userProfile"] });
};

export const invalidateHabitQueries = (queryClient) => {
  if (!queryClient) {
    console.warn("QueryClient not provided to invalidateHabitQueries");
    return;
  }

  // Invalidate habit-related queries
  queryClient.invalidateQueries({ queryKey: ["dashboard", "habits"] });
  // Habits affect power streak counts (including today)
  queryClient.invalidateQueries({ queryKey: ["dashboard", "userStreaks"] });
};

export const invalidateTaskQueries = (queryClient) => {
  if (!queryClient) {
    console.warn("QueryClient not provided to invalidateTaskQueries");
    return;
  }

  // Invalidate task-related queries
  queryClient.invalidateQueries({ queryKey: ["taskManagement", "mitTasks"] });
  queryClient.invalidateQueries({ queryKey: ["taskManagement", "doLists"] });
  queryClient.invalidateQueries({
    queryKey: ["taskManagement", "tasksByDate"],
  });
  // Task completion or kanban moves can update power streaks (/v3/streak)
  queryClient.invalidateQueries({ queryKey: ["dashboard", "userStreaks"] });
};

export const invalidateGoalQueries = (queryClient) => {
  if (!queryClient) {
    console.warn("QueryClient not provided to invalidateGoalQueries");
    return;
  }

  // Invalidate goal-related queries
  queryClient.invalidateQueries({ queryKey: ["goalsAndTargets", "goals"] });
  queryClient.invalidateQueries({
    queryKey: ["goalsAndTargets", "reflections"],
  });
};
